import React, { useState, useEffect } from 'react';
import '../style/css/loading.css'
import utils from "../services/utils";

const Loading = () => {
    const [dotCount, setDotCount] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setDotCount((prevDotCount) => (prevDotCount + 1) % 5);
        }, 500); // Adjust the interval time as needed

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="loader-container">
            <div className="loader"></div>
            <div className="loading-text">
                {utils.useLang('LOADING')}
                {'.'.repeat(dotCount)}
            </div>
        </div>
    );
};

export default Loading;